"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./components/DetailsList/index"));

//# sourceMappingURL=DetailsList.js.map



//////////////////
// WEBPACK FOOTER
// ../DetailsList.js
// module id = 115
// module chunks = 0